import { render, staticRenderFns } from "./order-listing-web.vue?vue&type=template&id=68b8e5ac&"
import script from "./order-listing-web.vue?vue&type=script&lang=js&"
export * from "./order-listing-web.vue?vue&type=script&lang=js&"
import style0 from "./order-listing-web.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports